module.exports = __webpack_public_path__ + "static/media/eimi-fukada-icon.5e99c74e.jpg";